import React, { useEffect } from 'react';
import { useControls, folder } from 'leva';
import lightSettings from '../../../settings/light';

/**
 * Optional light / exposure tuner.
 * Enable: localStorage.setItem('radivas_leva', '1') + reload.
 */
export function isLevaEnabled() {

  try {

    return typeof window !== 'undefined'
      && window.localStorage?.getItem( 'radivas_leva' ) === '1';

  } catch ( e ) {

    return false;

  }

}

export function LightLevaPanel({

  balkonType,
  lookExposure,
  onLightOverride,
  onExposureOverride,

}) {

  const base = lightSettings[ +balkonType ] || lightSettings[ 1 ];

  const values = useControls(

    'Radivas Light',
    {

      exposure: { value: lookExposure, min: 0.4, max: 1.6, step: 0.01 },

      directional: folder({

        dirX: { value: base.directional.x, min: -150, max: 150, step: 0.01 },
        dirY: { value: base.directional.y, min: -150, max: 150, step: 0.01 },
        dirZ: { value: base.directional.z, min: -150, max: 150, step: 0.01 },
        dirIntensity: { value: base.directional.intensity, min: 0, max: 2.5, step: 0.01 },

      }),

      spot: folder({

        spotX: { value: base.spot.x, min: -100, max: 100, step: 0.05 },
        spotY: { value: base.spot.y, min: -100, max: 100, step: 0.05 },
        spotZ: { value: base.spot.z, min: -100, max: 100, step: 0.05 },
        spotIntensity: { value: base.spot.intensity, min: 0, max: 2.5, step: 0.01 },
        spotDecay: { value: base.spot.decay, min: -5, max: 5, step: 0.01 },

      }),

      ambient: folder({

        ambientIntensity: { value: base.ambient.intensity, min: 0, max: 1, step: 0.01 },

      }),

      target: folder({

        tgtX: { value: base.target.x, min: -20, max: 20, step: 0.05 },
        tgtY: { value: base.target.y, min: -20, max: 20, step: 0.05 },
        tgtZ: { value: base.target.z, min: -20, max: 20, step: 0.05 },

      }),

    },
    { collapsed: false },
    [ balkonType ]

  );

  useEffect(() => {

    onExposureOverride && onExposureOverride( values.exposure );

    onLightOverride && onLightOverride({

      ambient: { intensity: values.ambientIntensity },
      target: { x: values.tgtX, y: values.tgtY, z: values.tgtZ },
      directional: {

        x: values.dirX,
        y: values.dirY,
        z: values.dirZ,
        intensity: values.dirIntensity,

      },
      spot: {

        x: values.spotX,
        y: values.spotY,
        z: values.spotZ,
        intensity: values.spotIntensity,
        decay: values.spotDecay,
        angle: base.spot.angle,

      },

    });

  }, [ values, onLightOverride, onExposureOverride, base.spot.angle ]);

  return null;

}
